import { FC, useMemo } from 'react';

import {
  isDotActive,
  ProgressBarPalette,
  ZERO_PROGRESS_SMALL_WIDTH,
} from '../helpers';
import { useProgressBarPallete } from 'hooks/progressBarPallete';

import { ScProgressBar } from './styled';

interface SmallProgressConfig {
  dotsCount?: number;
  color?: ProgressBarPalette;
}

interface SmallProgressProps {
  userProgress: number;
  config: SmallProgressConfig;
}

export const SmallProgressBar: FC<SmallProgressProps> = ({
  userProgress,
  config,
}) => {
  const { dotsCount, color } = config;

  const colorPallete = useProgressBarPallete();

  const progressBarColor = colorPallete[color || ProgressBarPalette.CLOUD];

  const progress = useMemo(() => {
    return userProgress ? `${userProgress}%` : ZERO_PROGRESS_SMALL_WIDTH;
  }, [userProgress]);

  return (
    <ScProgressBar $progress={progress} $color={progressBarColor}>
      <div className="progress-wrapper">
        {dotsCount && (
          <div className="dots">
            {[...Array(dotsCount)].map((_, index) => (
              <span
                key={index}
                className={`dot ${
                  isDotActive(index, userProgress, dotsCount) ? 'active' : ''
                }`}
              />
            ))}
          </div>
        )}
        <div className="progress-bar-line" />
      </div>
    </ScProgressBar>
  );
};
